export const LEGAL_DOCUMENTS: {
  label: string;
  url: string;
}[] = [
  {
    label: 'Terms of Service',
    url: 'https://advisorinterview.com/documents/Terms%20of%20Service.pdf',
  },
  {
    label: 'Privacy Policy',
    url: 'https://advisorinterview.com/documents/Privacy%20Policy.pdf',
  },
];
